export default {"src":"/_next/static/media/e-commerce-platforms.87063dc9.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};